<template>
  <div class="container h-screen">
    <div class="flex flex-col justify-center h-full">
      <div class="mb-6 mx-auto">
        <img src="@/assets/images/illustration_2.svg" alt="illustration" />
      </div>
      <h1 class="heading-1">
        {{ title }}
      </h1>
      <div class="spacer"></div>
      <p class="mb-20">{{ description }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FeedbackNegativeView extends Vue {
  private get title(): string {
    return this.$store.getters['negativeReviewTitle'];
  }

  private get description(): string {
    return this.$store.getters['negativeReviewDescription'];
  }
}
</script>
